import { ref, computed, watch } from 'vue';
import Request from '@/services/request';
import { HISTORY_TAB_DOWNLOAD } from '@/utils/enum/bulkActionTabs';
import { SELLEROFFICE_API_BASE_URL } from '@/utils/enum/endpoints';

const Req = new Request();

const DEFAULT_PAGE_COUNT = -1;
const DEFAULT_RESULT_COUNT = -1;

export default function useJoinCampaignBulkService(
  pagination,
  campaignId,
  refreshTrigger,
) {
  const data = ref(null);
  const totalResultCount = ref(DEFAULT_RESULT_COUNT);
  const error = ref(null);
  const isLoading = ref(false);
  const pageCount = ref(DEFAULT_PAGE_COUNT);

  const requestParams = computed(() => {
    const { pageSize, pageIndex } = pagination.value;
    return {
      page: pageIndex,
      size: pageSize,
      campaignId: campaignId.value,
      type: pagination.value.tab,
    };
  });

  const fetchData = async () => {
    if (!campaignId.value) return;

    isLoading.value = true;
    let endpoint =
      pagination.value.type === HISTORY_TAB_DOWNLOAD
        ? `/umbrella-campaigns/${campaignId.value}/bulk-products/template`
        : `/umbrella-campaigns/${campaignId.value}/bulk-products/statistics`;

    try {
      const response = await Req.get(endpoint, requestParams.value, {
        baseURL: SELLEROFFICE_API_BASE_URL,
      });
      if (response.status === 200) {
        data.value =
          response.data.statistics || response.data.bulkTemplateList || [];
        totalResultCount.value =
          response.data.pagingModel?.totalCount || DEFAULT_RESULT_COUNT;
        pageCount.value =
          response.data.pagingModel?.pageCount || DEFAULT_PAGE_COUNT;
        error.value = null;
      } else {
        throw new Error('Network response was not OK');
      }
    } catch (err) {
      error.value = err || null;
      data.value = [];
      pageCount.value = 0;
    } finally {
      isLoading.value = false;
    }
  };

  watch(
    () => [
      pagination.value.pageIndex,
      pagination.value.type,
      campaignId.value,
      refreshTrigger?.value,
    ],
    () => {
      fetchData();
    },
    { immediate: true, deep: true },
  );

  return {
    data,
    totalResultCount,
    pageCount,
    error,
    isLoading,
  };
}
